import "./IconRedCircleX.scss";
import { ReactComponent as RedCircleX } from "./svg/redCircleX.svg";

export const IconRedCircleX = () => {
  return (
    <span className={`icon-red-circle-x`}>
      <RedCircleX />
    </span>
  );
};
